import { render, staticRenderFns } from "./DialogAddEmail.vue?vue&type=template&id=12c0b7a5&"
import script from "./DialogAddEmail.vue?vue&type=script&lang=js&"
export * from "./DialogAddEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports